// extracted by mini-css-extract-plugin
module.exports = {"quantityup_down":"ProductQuantity_quantityup_down__2jUyy","number":"ProductQuantity_number__14Iow","value_button":"ProductQuantity_value_button__2iwJ2"};